<div class="instructions p-0">
  <h5>Instructions</h5> <p *ngIf="task.content.instructions.length">{{ task.content.instructions }}</p>
  <button [routerLink]="'/survey/task/' + task.id" class="btn btn-lg btn-primary btn-block mb-3">
    Start Questionnaire
  </button>
</div>
<div>
  <h5>{{ task.taskOptionsTitle }}</h5> <p>{{ task.taskOptionsDescription }}</p>
</div>
